<template>

  <div class="food-card bg-white border-" :id="`un-auth-side-product-${food.id}`">
    <b-row>
      <b-col lg="6">
        <img class="w-100  shop-food-img" :src="food.thumbnail" :alt="food.name"/>
      </b-col>
      <b-col lg="6" class="d-flex flex-column align-items-start justify-content-center text-right ">
        <h5 class="text-dark my-1">{{ contentSlicer(food.name,45) }}</h5>
        <m-product-price-100 :product="food"/>
        <slot name="comment-btn"></slot>
      </b-col>
      <b-col lg="12" class="my-3">
        <m-shopping-cart-controller-1 :product="food"/>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {mapGetters} from "vuex";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "C17",
  props: ['food', 'basket'],
  data() {
    return {
      count: 0,
      restaurantActive: null,
      foodActive: null
    }
  },
  computed: {
    ...mapGetters({
      IsAuthenticated: "User/isAuthenticated"
    }),
  },
  methods: {
    getFormattedNumber(number) {
      return formatNumber(number)
    },
    checkOrder(food) {
      let result = false;
      if (this.basket.items !== undefined) {
        this.basket.items.forEach(orderFood => {
          if (orderFood.product.id === food.id) {
            result = true
          }
        })
      }
      return result
    },
    getQuantity(id) {
      let quantity = 0
      this.basket.items.forEach(orderFood => {
        if (orderFood.product.id === id) {
          quantity = orderFood.quantity
        }
      })
      return quantity
    },
    getOrderItemId(food) {
      let itemId = 0
      this.basket.items.forEach(orderFood => {
        if (orderFood.product.id === food.id) {
          itemId = orderFood.id
        }
      })
      return itemId
    },
    addToOrder(food, basket) {
      this.$store.dispatch("ShoppingCart/addItem", {product_id: [food.id], basket_id: basket.id})
    },
    changeItemQuantity(food, quantity, basket) {
      this.$store.dispatch("ShoppingCart/updateItem", {
        order_product_id: this.getOrderItemId(food),
        quantity: quantity - 1,
        basket_id: basket.id
      })
    },
    removeFromOrder(food, basket) {
      this.$store.dispatch("ShoppingCart/removeItem", {
        order_product_id: this.getOrderItemId(food),
        basket_id: basket.id
      })

    },
    isRestaurantActive() {
      if (this.food.brand) {
        let restaurant = this.food.brand
        if ('timable' in restaurant) {
          if (restaurant.timable.length !== 0) {
            this.restaurantActive = this.isTimingStarted(restaurant.timable.open_at, restaurant.timable.close_at);
          } else {
            this.restaurantActive = true
          }
        } else {
          this.restaurantActive = true
        }
      } else {
        this.restaurantActive = true
      }
    },
    isFoodActive() {
      if ('timable' in this.food) {
        if (this.food.timable.length !== 0) {
          this.foodActive = this.isTimingStarted(this.food.timable.open_at, this.food.timable.close_at);
        } else {
          this.foodActive = true
        }
      } else {
        this.foodActive = true
      }
    },
    isTimingStarted(start, end) {
      let _start = new Date(start)
      let _end = new Date(end)

      return Date.now() >= _start && Date.now() <= _end
    },
    addUnAuthItem(food) {
      this.$store.dispatch("ShoppingCart/addUnAuthItem", food)
      toast("", "محصول با موفقیت به سبد اضافه شد")
      this.$store.dispatch("Product/setProducts", 1)
    },
    checkUnAuthBasket(food) {
      if (localStorage.getItem('products') !== null) {
        let products = JSON.parse(localStorage.getItem('products'));
        return products.hasOwnProperty(food.id);
      } else {
        return false
      }
    },
    /* unauth shopping cart management */
    getUnAuthQuantityNumber(id) {
      let products = JSON.parse(localStorage.getItem('products'));
      return products[id]['quantity']
    },
    increaseUnAuthProductNumber(id) {
      let products = JSON.parse(localStorage.getItem('products'));
      products[id]['quantity']++;
      localStorage.setItem('products', JSON.stringify(products));
      let elementId = `un_auth_food_${id}`
      document.getElementById(elementId).textContent = products[id]['quantity'];
    },
    decreaseUnAuthProductNumber(id) {
      let products = JSON.parse(localStorage.getItem('products'));
      if (products[id]['quantity'] > 1) {
        products[id]['quantity']--;
        let elementId = `un_auth_food_${id}`
        document.getElementById(elementId).textContent = products[id]['quantity'];
      }
      localStorage.setItem('products', JSON.stringify(products));
    },
    removeFromUnAuthOrder(id) {
      let products = JSON.parse(localStorage.getItem('products'));
      delete products[id];
      localStorage.setItem('products', JSON.stringify(products));
      let elementId = `un-auth-side-product-${id}`
      document.getElementById(elementId).remove();
    },
    handleStorageChange() {
      this.$forceUpdate();
    }
  },
  async mounted() {
    await this.isFoodActive()
    await this.isRestaurantActive()
    // listen for changes in the local storage
    window.addEventListener('click', this.handleStorageChange);
  }
}
</script>

<style scoped>
.food-card {
  border-radius: 25px;
  padding: 5px;
  height: max-content;
}

.food-card .card-body {
  padding: 5px;
  margin: 0;
}

.q-link {
  height: 25px;
  line-height: 10px;
  background-color: var(--primary);
  color: var(--light);
}

.shop-food-img {
  border-radius: 25px;
  height: 150px;
  object-fit: cover;
}

.add-to-shopping-card {
  background-color: var(--primary);
  border: none;
}

.food-comment-btn {
  background-color: var(--secondary);
  color: var(--light);
}


.control-btn {
  text-decoration: none;
  padding: 0 3px 0;
  margin: 0px;
  color: white;
  font-weight: bold;
  width: max-content;
  height: max-content;
  border-radius: 100%;
}

.add-to-cart {
  border-radius: 15px;
}

.add-to-cart:hover {
  color: white !important;
}


</style>